module.exports = __webpack_public_path__ + "static/media/gallery_05.6df80cc4.png";